import {Badge, Icon} from '@sollapay/ui/components';

import type {FC} from 'react';

export interface RosterStatus {
  tone: 'error' | 'success';
  label: string;
}

export const RosterStatusBadge: FC<RosterStatus> = ({tone, label}) => (
  <Badge variant={tone} size="md" className="shrink-0" data-slot="roster-status-badge">
    {label}
    <Icon name={tone === 'error' ? 'alert-circle' : 'check'} className="size-3.5" />
  </Badge>
);
